export {default} from "./TxtHighlight";
export * from "./TxtHighlight";
